(function () {
  var path = window.location.pathname || "/";
  if (path.length > 1 && path.endsWith("/")) path = path.slice(0, -1);

  // Only on real recall pages
  var m = path.match(/^\/pages\/product-recalls-([^\/]+)$/);
  if (!m) return;

  var pretty = "/pages/product-recalls/" + m[1] + (window.location.search || "") + (window.location.hash || "");
  window.history.replaceState({}, "", pretty);
})();